import { render } from "./ResourceGroupDetail.vue?vue&type=template&id=8ab4014a&ts=true"
import script from "./ResourceGroupDetail.vue?vue&type=script&lang=ts"
export * from "./ResourceGroupDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__